export const LOAD_EMBALAJES_SUCCESS = 'LOAD_EMBALAJES_SUCCESS';

export interface EmbalajeState {
    id: number
    nombre: string
    alto: number
    largo: number
    ancho: number
    peso: number
    etiquetaEmbalaje: any
}

interface ILoadEmbalajes {
    type: typeof LOAD_EMBALAJES_SUCCESS
    embalajes: EmbalajeState[]
}

export type EmbalajeActionTypes = ILoadEmbalajes
